import { BaseComponent } from 'components/BaseComponent';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../components/Buttons';
import { createHemexInspection, fetchHemexStatus, requestHemexAuction } from '../actions';
import { selectVehicleHemexStatus } from '../selectors';
import { HBox, VBox } from '../../../components/Box';
import { selectWorks } from '../../Api/selectors';
import { CREATE_HEMEX_INSPECTION, FETCH_HEMEX_STATUS } from '../constants';
import { Loader } from '../../../components/Loader';
import { Well } from '../../../components/Well';
import { Cell, List, Row } from '../../../components/List';
import { PDF } from '../../../components/Icon';

const Container = styled.div`
  .request {
    padding: 12px;
    background-color: white;
    width: 300px;

    text-align: center;
    h3 {
      margin-bottom: 20px;
    }
  }
`;

const STATE = {
  date: dayjs()
    .add(7, 'days')
    .toDate(),
};

/* eslint-disable react/prefer-stateless-function */
class VehicleHemexComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
  }

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get entityId() {
    return this.vehicle?.id;
  }

  get entityType() {
    return 'vehicle';
  }

  onDateChange(value) {
    let date = dayjs(value).toDate();
    this.updateState('date', date);
    return this;
  }

  render() {
    if (this.props.loading) return <Loader onCard />;
    return (
      <Container>
        <HBox left gap={12}>
          {this.vehicle.hemex_object_id ? (
            this.renderInspectionStatus()
          ) : (
            <VBox flexStart className="request" center>
              {this.state.error ? (
                <Well alert>{this.state.error}</Well>
              ) : this.state.result ? (
                <Well success>Aanvraag gelukt</Well>
              ) : null}
              <h3>Inspectie aanvragen:</h3>
              <DatePicker dateFormat="dd-MM-yyyy" selected={this.state.date} onChange={this.onDateChange.bind(this)} />
              <Button
                small
                onClick={() =>
                  this.props.createInspection(dayjs(this.state.date).format('YYYY-MM-DD'), result => {
                    if (result?.response?.error) {
                      this.setState({ error: result?.response?.error, result: null });
                    } else {
                      this.setState({ error: null, result });
                    }
                  })
                }
              >
                Inspectie aanvragen
              </Button>
            </VBox>
          )}
          {this.renderAuction()}
        </HBox>
      </Container>
    );
  }

  renderInspectionStatus() {
    return (
      <VBox flexStart className="request" center>
        <Well>Inspectie aangevraagd:</Well>
        <List>
          <Row>
            <Cell>ID:</Cell>
            <Cell>{this.props.vehicle.hemex_object_id}</Cell>
          </Row>
          <Row>
            <Cell>Rapport id:</Cell>
            <Cell>{this.props.vehicle.hemex_opnameRapport_id}</Cell>
          </Row>
        </List>
        {this.props.hemexStatus?.faultstring ? (
          <Well warning>{this.props.hemexStatus?.faultstring}</Well>
        ) : this.props.hemexStatus?.pdf ? (
          <>
            <Button onClick={() => window.open(this.props.hemexStatus?.pdf)}>
              <PDF /> Inspectie rapport
            </Button>
          </>
        ) : (
          <Well>{JSON.stringify(this.props.hemexStatus)}</Well>
        )}
      </VBox>
    );
  }

  renderAuction() {
    if (!this.props.hemexStatus?.pdf) return null;
    return (
      <VBox flexStart className="request" center>
        <Button
          onClick={() => {
            // eslint-disable-next-line no-restricted-globals
            confirm('Veiling aanvragen')
              ? this.props.requestAuction(result => {
                  // eslint-disable-next-line no-debugger
                  debugger;
                })
              : null;
          }}
        >
          Veiling aanvragen
        </Button>
      </VBox>
    );
  }
}

VehicleHemexComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWorks([CREATE_HEMEX_INSPECTION, FETCH_HEMEX_STATUS]),
    hemexStatus: selectVehicleHemexStatus(ownProps.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    createInspection(date, callback) {
      dispatch(createHemexInspection(ownProps.vehicle.id, ownProps.vehicle.regplate, date, callback));
    },
    requestAuction(callback) {
      dispatch(requestHemexAuction(ownProps.vehicle.id, callback));
    },
    fetch() {
      dispatch(fetchHemexStatus(ownProps.vehicle.id));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const VehicleHemex = compose(
  withConnect,
  withRouter,
)(VehicleHemexComp);
